import type React from "react"
import { Card } from "../ui/card-animated"
import { YouTubeVideo } from "../ui/youtube-video-animated"

interface InfoVideoSectionProps {
  videoId: string
  title?: string
}

export const InfoVideoSection: React.FC<InfoVideoSectionProps> = ({ videoId, title }) => {
  return (
    <Card title="Video Informativo" delay={5}>
      <div className="space-y-4">
        <YouTubeVideo videoId={videoId} title={title} />
      </div>
    </Card>
  )
}
